import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './login';
import { ForgotPasswordPage } from './forgot-password';
import { RootLayout } from './root';
import { DashboardPage } from './dashboard';
import { AnalyticsPage } from './analytics';
import { EndpointDetailsPage } from './endpoint-details';
import { SecurityPage } from './security';
import { LogDebuggerPage } from './log-debugger';
import { Component as UsersMigrationPage } from './users-migration';
import { Component as UserManagementPage } from './user-management';
import { Component as AppVersionsPage } from './app-versions';
import { Component as CacheManagementPage } from './cache-management';
import { Component as GroupOrdersPage } from './group-orders';
import { Component as ArchiveManagementPage } from './archive-management';
import { Component as ApiKeysPage } from './api-keys';
import { Component as TeamPage } from './team';
import GlobalConfigPage from './global-config';
import FeatureFlagsPage from './feature-flags';
import TenantFeatureFlagsPage from './tenant-feature-flags';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { NotFoundRedirect } from '@/components/NotFoundRedirect';

/**
 * Application Router Configuration
 *
 * Defines all routes with React Router v7 component-based routing.
 * Protected routes require authentication (implemented in Phase 2).
 *
 * Route Structure:
 * - /login: Public authentication page
 * - /: Protected root with child routes
 *   - /dashboard: Main audit logs view
 *   - /analytics: Analytics dashboard (Phase 4)
 *   - /security: Security anomalies (Phase 5)
 * - *: Smart redirect based on auth status
 *
 * Note: Using component-based routing ensures routes are evaluated lazily
 * when rendered, which allows ProtectedRoute to access AuthContext correctly.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RootLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users-migration" element={<UsersMigrationPage />} />
        <Route path="user-management" element={<UserManagementPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="app-versions" element={<AppVersionsPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="cache-management" element={<CacheManagementPage />} />
        <Route path="group-orders" element={<GroupOrdersPage />} />
        <Route path="archive-management" element={<ArchiveManagementPage />} />
        <Route path="global-config" element={<GlobalConfigPage />} />
        <Route path="feature-flags" element={<FeatureFlagsPage />} />
        <Route path="tenant-feature-flags" element={<TenantFeatureFlagsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="analytics/endpoint/:endpoint" element={<EndpointDetailsPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="log-debugger" element={<LogDebuggerPage />} />
      </Route>

      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  );
}
